module.exports = __webpack_public_path__ + "static/media/pointA.d33f0941.png";